import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ShadowConstraintService } from "src/app/services/shadowConstraint.service";
import { ToastService } from "src/app/services/toast.service";
import { ShadowConstraint } from "src/app/models/shadowConstraint.model";
import nameOf from "src/app/shared/form/nameOf.helper";
import { ConstraintTypeEnum } from "src/app/enums/constraintType.enum";
import {
    ConfirmDialogComponent,
    ConfirmDialogData,
} from "src/app/shared/confirmDialog/confirmDialog.component";
import { AuthService } from "src/app/services";
import { TimeZoneService } from "src/app/services/timeZone.service";
import { BaseGridComponent } from "src/app/shared/grid/baseGrid.component";
import { CreateShadowConstraintDialogComponent } from "src/app/modals/createShadowConstraintDialog/createShadowConstraintDialog.component";
import { EditShadowConstraintDialogComponent } from "src/app/modals/editShadowConstraintDialog/editShadowConstraintDialog.component";
import { CommonService } from "src/app/services/common.service";
import { GridViewService } from "src/app/services/grid-view.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  standalone: false,
    selector: "app-shadow-constraint-list",
    templateUrl: "shadowConstraintList.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["shadowConstraintList.component.scss"],
})
export class ShadowConstraintListComponent extends BaseGridComponent<ShadowConstraint> {
    ConstraintTypeEnum = ConstraintTypeEnum;
    timeZoneLabel: string;

    constructor(
        protected shadowConstraintService: ShadowConstraintService,
        toastService: ToastService,
        authService: AuthService,
        timeZoneService: TimeZoneService,
        dialog: MatDialog,
        commonService: CommonService,
        gridViewService: GridViewService,
        private translateService: TranslateService,
    ) {
        super(toastService, dialog, commonService, gridViewService);
        this.timeZoneLabel = timeZoneService.createTimeZoneLabel(
            authService.getCurrentUser().userTimeZone,
        );
        this.gridService = shadowConstraintService;
        this.displayedColumns = [
            "DeviceVersion.Version",
            nameOf<ShadowConstraint>((x) => x.field),
            nameOf<ShadowConstraint>((x) => x.constraintType),
            nameOf<ShadowConstraint>((x) => x.operatorType),
            nameOf<ShadowConstraint>((x) => x.operatorValue),
            nameOf<ShadowConstraint>((x) => x.operatorType2),
            nameOf<ShadowConstraint>((x) => x.operatorValue2),
            "action",
        ];
    }

    add() {
        const dialogRef = this.dialog.open(
            CreateShadowConstraintDialogComponent,
            {
                data: {},
                width: "450px",
                disableClose: true,
            },
        );
        this.handleDialogClose(dialogRef);
    }

    edit(shadowConstraint: ShadowConstraint) {
        const dialogRef = this.dialog.open(
            EditShadowConstraintDialogComponent,
            {
                data: { id: shadowConstraint.id },
                width: "450px",
                disableClose: true,
            },
        );
        this.handleDialogClose(dialogRef);
    }

    delete(shadowConstraint: ShadowConstraint) {
        const data: ConfirmDialogData = {
            title: this.translateService.instant("Delete Shadow Constraint"),
            message: this.translateService.instant(
                "Are you sure you want to delete this shadow constraint?",
            ),
            primaryButtonText: this.translateService.instant("Delete"),
            primaryCallback: () =>
                this.shadowConstraintService.delete(shadowConstraint.id),
            successMessage: this.translateService.instant(
                "Shadow constraint deleted successfully!",
            ),
            secondaryButtonText: this.translateService.instant("Cancel"),
            errorMessage: "",
        };
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data,
            width: "450px",
            disableClose: true,
        });
        this.handleDialogClose(dialogRef);
    }
}
